const istate = {
  id: "",
  name: "",
  email: "",
  role: "",
  image: "",
  phone: "",
  token: "",
  islogin: false,
  totp: "",
  clientId: "",
  sidebar: [],
  permissions: {},
};

const authReducer = (state = istate, action) => {
  const {
    id,
    name,
    email,
    phone,
    role,
    image,
    totp,
    token,
    clientId,
    sidebar,
    permissions,
  } = action?.payload || {};
  switch (action.type) {
    case "LOGIN": {
      state = {
        ...state,
        id,
        name,
        email,
        phone,
        role,
        image,
        totp,
        token,
        clientId,
        islogin: true,
        sidebar,
        permissions,
      };
      return state;
    }
    case "LOGOUT": {
      state = {
        ...state,
        id: "",
        name: "",
        email: "",
        role: "",
        image: "",
        phone: "",
        totp: "",
        token: "",
        clientId: "",
        islogin: false,
        sidebar: [],
        permissions: {},
      };
      return state;
    }
    case "UPDATE_PROFILE": {
      state = {
        ...state,
        name,
        email,
        phone,
        image: image || state.image,
      };
      return state;
    }
    case "UPDATE_GOOGLE_SECRET": {
      state = {
        ...state,
        totp,
      };
      return state;
    }
    default:
      return state;
  }
};

export default authReducer;
